import style from "./ProfileTabs.module.css";

import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";

import { useGetUserSavedCourses } from "../../hooks/useGetUserSavedCourses";
import { useGetUserLikedVideos } from "../../hooks/useGetUserLikedVideos";
import { useGetUserCertificates } from "@/features/certificates/hooks/useGetUserCertificates";
import { useGetUserByUsername } from "@/features/auth/hooks/useGetUserByUsername";
import { useUser } from "@/features/auth/hooks/useUser";

import { padZero } from "@/utils/helpers";

function ProfileTabs({ username }) {
	const { t } = useTranslation();
	const { courses, isPending: savedIsPending } =
		useGetUserSavedCourses(username);
	const { likedVideos, isPending: likedIsPending } =
		useGetUserLikedVideos(username);
	const { certificates, isPending: certificatesPenidng } =
		useGetUserCertificates(username);
	const { user, isPending: userIsPending } = useGetUserByUsername(username);
	const { user: owner, isPending: ownerIsPending } = useUser();

	// return skelton here
	if (
		savedIsPending &&
		likedIsPending &&
		certificatesPenidng &&
		userIsPending &&
		ownerIsPending
	)
		return <></>;

	return (
		<nav className={style.tabs}>
			<ul>
				<li>
					<NavLink to={`/u/${username}`} end>
						<Icon icon="fa-file-certificate" />
						<span>{t("auth:profile.tabs.certificates")}</span>
						{certificates?.length > 0 &&
							!user?.isSubscribed &&
							user?.username == owner?.username && (
								<span className={style.badge}>
									{padZero(certificates?.length)}
								</span>
							)}
					</NavLink>
				</li>
				<li>
					<NavLink to="saved-courses">
						<Icon icon="fa-bookmark" />
						<span>{t("auth:profile.tabs.courses")}</span>
						{courses?.length > 0 && (
							<span className={style.badge}>
								{padZero(courses?.length)}
							</span>
						)}
					</NavLink>
				</li>
				<li>
					<NavLink to="liked-videos">
						<Icon icon="fa-heart" />
						<span>{t("auth:profile.tabs.liked")}</span>
						{likedVideos?.length > 0 && (
							<span className={style.badge}>
								{padZero(likedVideos?.length)}
							</span>
						)}
					</NavLink>
				</li>
			</ul>
		</nav>
	);
}

export default ProfileTabs;
